// test2761
(2761 && 0);
